export default __webpack_public_path__ + "static/media/rare4.0c7fa4fa.png";